import { useEffect, useRef, useState } from "react";
import { getConsent, subscribeConsent } from "@/lib/consent";

// Crisp chat widget — gated behind chat-cookie consent (UK GDPR / PECR).
const CRISP_ID = process.env.REACT_APP_CRISP_WEBSITE_ID;

const Crisp = () => {
  const loaded = useRef(false);
  const [chatAllowed, setChatAllowed] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (c && c.chat) setChatAllowed(true);
    return subscribeConsent((next) => setChatAllowed(Boolean(next.chat)));
  }, []);

  useEffect(() => {
    if (!chatAllowed || !CRISP_ID || loaded.current || window.$crisp) return;
    loaded.current = true;

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = CRISP_ID;

    const s = document.createElement("script");
    s.src = "https://client.crisp.chat/l.js";
    s.async = 1;
    document.getElementsByTagName("head")[0].appendChild(s);
  }, [chatAllowed]);

  return null;
};

export default Crisp;
